<template>
  <div class="contenidor text-1sm" @click="toggleExtra">
    <div class="label">{{ label }}</div>
    <div class="additional-value">{{ price | money }}</div>

    <inline-svg
      class="check"
      :src="enabled ? '/img/icons/icon-checkactive.svg' : '/img/icons/icon-check.svg'"
    />
  </div>
</template>

<script>

  export default {
    name: "ria-checkbox-extra",
    props: {
      label: String,
      price: Number,
      extraId: Number,
      enabled: Boolean
    },
    methods: {
      toggleExtra: function() {
        this.enabled = !this.enabled
        this.$emit("change", { id: this.extraId, enabled: this.enabled });
      }
    },
  };
</script>

<style scoped>

  .contenidor {
    @apply h-10 flex justify-between items-center border-grey-border border-b-1 mb-3;
  }

  .label {
    @apply text-sm tracking-3xl text-black flex-grow uppercase;
  }

  .additional-value {
    @apply text-base tracking-base text-black;
  }

  .check {
    @apply w-5 h-5 ml-3 object-contain cursor-pointer;
  }

</style>
